import { makeStyles } from '@material-ui/core/styles';
import { getStyle, mergeStyles } from './stylesSelector';
import { cloneDeep } from 'lodash';
import { styleBreakDesktop, styleBreakSmallMobile } from '../components/utilities/layouts/Globals';
import { FONT_WEIGHT_BOLD } from '../components/utilities/Material';

export const LabRequisitionHomeStyle = makeStyles(theme => {
    /* Default Styles */
    const defaultstyles = {
        subTitle: {
            marginTop: theme.spacing(2),
            color: theme.palette.text.primary,
        },
        subTitleManual: {
            paddingTop: theme.spacing(0.5),
            marginLeft: theme.spacing(2),
        },
        firstGridRow: {
            marginTop: theme.spacing(2),
            [styleBreakDesktop(theme)]: {
                marginTop: theme.spacing(3),
            },
        },
        gridRow: {
            marginTop: theme.spacing(2),
        },
        gridRowLessTop: {
            marginTop: theme.spacing(1),
        },
        gridIcon: {
            width: theme.spacing(4),
        },
        gridIconManual: {
            marginTop: theme.spacing(2),
        },
        gridTextManual: {
            marginLeft: theme.spacing(4.5),
            paddingTop: 0,
            marginTop: theme.spacing(1),
            color: theme.palette.text.primary,
        },
        listText: {
            paddingTop: theme.spacing(0.5),
            marginLeft: theme.spacing(2),
            fontWeight: FONT_WEIGHT_BOLD,
            color: theme.palette.text.primary,
        },
        bulletPointText: {
            marginLeft: theme.spacing(1.5),
        },
        unorderedList: {
            paddingLeft: theme.spacing(2.5),
            margin: theme.spacing(1),
        },
        leftPaddedContent: {
            paddingLeft: theme.spacing(1.45),
        },
        hiddenGridIcon: {
            //Hide icon but still takes up space to keep margins
            visibility: 'hidden',
        },
        gridText: {
            marginLeft: theme.spacing(2),
            paddingTop: theme.spacing(0.5),
            color: theme.palette.text.primary,
        },
        buttonContainer: {
            marginLeft: theme.spacing(2),
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(5),
        },
        button: {
            padding: 0,
            '& svg > path': {
                stroke: theme.palette.primary.dark
            }
        },
        contentContainer: {
            paddingTop: theme.spacing(0.75),
            paddingBottom: theme.spacing(3),
            [styleBreakSmallMobile(theme)]: {
                paddingBottom: theme.spacing(2),
            },
        },
        footer: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2),
            backgroundColor: theme.palette.background.default,
            borderRadius: '4px',
        },
        footTypographyTitle: {
            fontWeight: FONT_WEIGHT_BOLD,
            marginBottom: theme.spacing(0.5),
        },
        footTypographyTitleNoMargin: {
            fontWeight: FONT_WEIGHT_BOLD,
        },
        startMargin: {
            marginRight: theme.spacing(2),
        },
        ellipseStyle: {
            marginLeft: theme.spacing(6),
            width: theme.spacing(1),
            paddingTop: theme.spacing(0.5),
        },
        downloadStyle: {
            marginLeft: theme.spacing(4.5),
        },
        downloadText: {
            textAlign: 'left',
            fontWeight: FONT_WEIGHT_BOLD,
            paddingTop: '7px',
        },
        // numbered bullet point
        bulletIcon: {
            borderRadius: '50%',
            backgroundColor: theme.palette.primary.main,
            width: theme.spacing(4),
            height: theme.spacing(4),
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '& span': {
                fontWeight: 700,
                color: theme.palette.primary.contrastText,
            }
        }
    };

    // overrides to the default
    /* Add watchman specific styles */
    const watchmanstyles = mergeStyles(cloneDeep(defaultstyles), {
        button: {
            padding: 0,
            '& svg > path': {
                stroke: theme.palette.primary.dark
            }
        },
    });

    /* Add ned specific styles */
    // overrides to the default
    const nedstyles = mergeStyles(cloneDeep(defaultstyles), {
        button: {
            padding: 0,
            '& svg > path': {
                stroke: theme.palette.primary.main
            }
        },
    });

    return getStyle({
        ned: nedstyles,
        watchman: watchmanstyles
    });
});
